const RotasHome = () => import(/* webpackChunkName: "group-pabx-rotas" */ '../_views/RotasHome')
const CadastroRotas = () => import(/* webpackChunkName: "group-pabx-rotas" */ '../_views/CadastroRotas')
const AtualizarRotas = () => import(/* webpackChunkName: "group-pabx-rotas" */ '../_views/AtualizarRotas')
const CopiarRota = () => import(/* webpackChunkName: "group-pabx-rotas" */ '../_views/CopiarRota')

import { permissionsPabx } from '../../../../../../utils/permissionsPabx'

export default [
  {
    path: 'rotas-pabx',
    component: RotasHome,
    meta: { requiresAuth: true, permissions: [...permissionsPabx] },
    name: 'Rotas',
  },
  {
    path: 'rotas-pabx/criar',
    component: CadastroRotas,
    meta: { requiresAuth: true, permissions: [...permissionsPabx] },
    name: 'Rotas/criar',
  },
  {
    path: 'rotas-pabx/atualizar/:_id',
    component: AtualizarRotas,
    meta: { requiresAuth: true, permissions: [...permissionsPabx] },
    name: 'Rotas/atualizar',
    props: true,
  },
  {
    path: 'rotas-pabx/copiar/:_id',
    component: CopiarRota,
    meta: { requiresAuth: true, permissions: [...permissionsPabx] },
    name: 'Rotas/copiar',
    props: true,
  },
]
